import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ProductProperty } from '@getaccept/lib-shared/src/product-library/product-properties/types/product-property';

export const useProductPropertiesStore = defineStore('product-properties', () => {
  const productProperties = ref<ProductProperty[]>([]);

  const setProductProperties = (newProductProperties: ProductProperty[]) => {
    productProperties.value = newProductProperties;
  };

  return {
    productProperties,
    setProductProperties,
  };
});
